const API_BASE = '/api';

const getToken = () => localStorage.getItem('rmw_token');

const authHeaders = () => {
  const token = getToken();
  return token
    ? { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` }
    : { 'Content-Type': 'application/json' };
};

const handleResponse = async (res) => {
  const data = await res.json().catch(() => ({}));
  if (!res.ok) throw new Error(data.error || `HTTP ${res.status}`);
  return data;
};

export const authAPI = {
  register: async (username, password, displayName) => {
    const res = await fetch(`${API_BASE}/auth/register`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ username, password, displayName }),
    });
    return handleResponse(res);
  },

  login: async (username, password) => {
    const res = await fetch(`${API_BASE}/auth/login`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ username, password }),
    });
    return handleResponse(res);
  },

  me: async () => {
    const res = await fetch(`${API_BASE}/auth/me`, {
      headers: authHeaders(),
    });
    return handleResponse(res);
  },
};

export const designsAPI = {
  list: async () => {
    const res = await fetch(`${API_BASE}/designs`, { headers: authHeaders() });
    return handleResponse(res);
  },

  get: async (id) => {
    const res = await fetch(`${API_BASE}/designs/${id}`, { headers: authHeaders() });
    return handleResponse(res);
  },

  save: async (designData) => {
    const res = await fetch(`${API_BASE}/designs`, {
      method: 'POST',
      headers: authHeaders(),
      body: JSON.stringify(designData),
    });
    return handleResponse(res);
  },

  update: async (id, designData) => {
    const res = await fetch(`${API_BASE}/designs/${id}`, {
      method: 'PUT',
      headers: authHeaders(),
      body: JSON.stringify(designData),
    });
    return handleResponse(res);
  },

  rename: async (id, name) => {
    const res = await fetch(`${API_BASE}/designs/${id}/name`, {
      method: 'PATCH',
      headers: authHeaders(),
      body: JSON.stringify({ name }),
    });
    return handleResponse(res);
  },

  delete: async (id) => {
    const res = await fetch(`${API_BASE}/designs/${id}`, {
      method: 'DELETE',
      headers: authHeaders(),
    });
    return handleResponse(res);
  },
};

export const isLoggedIn = () => !!getToken();
